export default "__VITE_ASSET__Bg0N0scS__"